export const navigation = {
  about: "À propos",
  activities: "Journal d'activité",
  administration: "Administration",
  assets: "Actifs",
  assetTypes: "Types d'actifs",
  browse: "Naviguer par",
  collapse: "Rétracter",
  dashboard: "Tableau de bord",
  events: "Mes événements",
  expand: "Étendre",
  import: "Outil d'importation",
  interventions: "Interventions",
  interventionTemplates: "Gabarits d'intervention",
  language: "Langue",
  locations: "Localisations",
  logout: "Déconnexion",
  mySpace: "Mon espace",
  observations: "Observations",
  organizations: "Organisations",
  pageError: {
    notFound: {
      title: "Page non trouvée",
      description: "La page «{{path}}» n'existe pas.",
    },
    default: {
      title: "Une erreur s'est produite",
    },
    returnToDashboard: "Retourner au tableau de bord",
    returnToLogin: "Retourner à la page de connexion",
  },
  password: "Changer le mot de passe",
  preferences: "Préférences",
  projects: "Projets",
  support: "Support",
  technicalForms: "Formulaires techniques",
  users: "Utilisateurs",
};
